module.exports = __webpack_public_path__ + "img/big-logo.7fc13c6a.png";